import {createAction, props} from "@ngrx/store";
import {FlowEvent} from "../../../shared/models";

export const flowEventAction = createAction(
    '[Emulator logs] Set flow event',
    props<{ flowEvent: FlowEvent }>()
);

export const clearEmulatorStateAction = createAction(
    '[Emulator logs] clear emulator state'
);